var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vehicle-block expanded" }, [
    _vm.titlePosition === "top"
      ? _c("div", { staticClass: "vehicle-header" }, [
          _c(
            "h5",
            {
              class: {
                "with-drivego-icon": _vm.currentVehicle.is_drive_and_go,
              },
            },
            [
              _vm.currentVehicle.is_drive_and_go
                ? _c("img", {
                    staticClass: "drivego-icon",
                    attrs: {
                      src: _vm.brandingImagesPath("/images/svgs/dg-icon.svg"),
                    },
                  })
                : _vm._e(),
              _vm._v(_vm._s(_vm.currentVehicle.name) + "\n        "),
            ]
          ),
          _vm._v(" "),
          _vm.currencyIsChanging
            ? _c("strong", { staticClass: "amount" }, [_vm._v("…")])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        class: [
          "vehicle-img expanded",
          { "row m-0": _vm.cardType === "us-source-booking" },
        ],
      },
      [
        _vm.currentVehicle.image
          ? _c(
              "div",
              {
                class: [
                  "vehicle-img-wrapper expanded",
                  { "col-4 p-1": _vm.cardType === "us-source-booking" },
                ],
                style:
                  _vm.cardType === "us-source-booking"
                    ? "background-image:url(" +
                      _vm.imageUrl(_vm.currentVehicle.image) +
                      ")"
                    : "",
              },
              [
                _c("div", {
                  staticClass:
                    "vehicle-image-overlay d-block d-lg-none expanded",
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "vehicle-image vehicle-fixed-height expanded",
                  attrs: {
                    src: _vm.imageUrl(_vm.currentVehicle.image),
                    alt: _vm.currentVehicle.name,
                  },
                  on: {
                    error: function ($event) {
                      return _vm.imageLoadFailed(_vm.currentVehicle.image)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.loyaltyDiscountApplied
                  ? _c("img", {
                      staticClass: "loyalty-medal",
                      attrs: {
                        src: _vm.userLoyalty.image,
                        alt: _vm.userLoyalty.name,
                      },
                    })
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.titlePosition !== "top"
          ? _c(
              "div",
              {
                class: [
                  "vehicle-header",
                  { "col-8 p-1": _vm.cardType === "us-source-booking" },
                ],
              },
              [
                _c(
                  "h5",
                  {
                    class: {
                      "with-drivego-icon": _vm.currentVehicle.is_drive_and_go,
                    },
                  },
                  [
                    _vm.currentVehicle.is_drive_and_go
                      ? _c("img", {
                          staticClass: "drivego-icon",
                          attrs: {
                            src: _vm.brandingImagesPath(
                              "/images/svgs/dg-icon.svg"
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(_vm._s(_vm.currentVehicle.name) + "\n            "),
                  ]
                ),
                _vm._v(" "),
                _vm.currencyIsChanging
                  ? _c("strong", { staticClass: "amount" }, [_vm._v("…")])
                  : _vm.activeProduct && _vm.activeProduct.total_price > 0
                  ? _c("strong", { staticClass: "amount" }, [
                      _vm._v(
                        _vm._s(
                          _vm.priceWithPaymentType(
                            _vm.totals,
                            _vm.quotePaymentType
                          )
                        )
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: [
          "vehicle-specs-icons expanded",
          { "pt-2 pb-2": _vm.cardType === "us-source-booking" },
        ],
      },
      [
        _c("div", { staticClass: "icon-spec" }, [
          _vm._v("\n            " + _vm._s(_vm.vehicle.group) + "\n        "),
        ]),
        _vm._v(" "),
        _vm.currentVehicle.refrigerated
          ? _c("div", { staticClass: "icon-spec" }, [
              _c("div", { staticClass: "vehicle-spec-item-icon" }, [
                _c("img", {
                  attrs: {
                    src: _vm.brandingImagesPath(
                      "/images/specs-icons/refrigerated-icon.svg"
                    ),
                    alt: "Refrigerated",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vehicle-spec-item-description" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.labels.refrigerated) +
                    "\n            "
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.currentVehicle.adults
          ? _c("div", { staticClass: "icon-spec" }, [
              _c("div", { staticClass: "vehicle-spec-item-icon" }, [
                _c("img", {
                  attrs: {
                    src: _vm.brandingImagesPath(
                      "/images/specs-icons/number-of-passengers-icon.svg"
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vehicle-spec-item-description" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.currentVehicle.adults) +
                    "\n            "
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.luggageLabel.short
          ? _c(
              "div",
              { staticClass: "icon-spec" },
              [
                _c(
                  "gm-tooltip",
                  { attrs: { text: _vm.luggageLabel.long, click: "enabled" } },
                  [
                    _c("div", { staticClass: "vehicle-spec-item-icon" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.brandingImagesPath(
                            "/images/specs-icons/number-of-bags-icon.svg"
                          ),
                          alt: "Number of bags",
                        },
                      }),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "vehicle-spec-item-description" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.luggageLabel.short) +
                      "\n            "
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentVehicle.fuel
          ? _c("div", { staticClass: "icon-spec" }, [
              _c("div", { staticClass: "vehicle-spec-item-icon" }, [
                _c("img", {
                  attrs: {
                    src: _vm.brandingImagesPath(
                      "/images/specs-icons/" + _vm.fuelType.icon
                    ),
                    alt: "Fuel type",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vehicle-spec-item-description" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.fuelType.label) +
                    "\n            "
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.vehicle.co2 > 0
          ? _c("div", { staticClass: "icon-spec" }, [
              _c("div", { staticClass: "vehicle-spec-item-icon" }, [
                _c("img", {
                  attrs: {
                    src: _vm.brandingImagesPath(
                      "/images/specs-icons/co2-icon.svg"
                    ),
                    alt: "CO2",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vehicle-spec-item-description" }, [
                _vm._v(_vm._s(_vm.currentVehicle.co2)),
                _c("sub", [_vm._v("2")]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.currentVehicle.air_conditioning
          ? _c("div", { staticClass: "icon-spec" }, [
              _c("div", { staticClass: "vehicle-spec-item-icon" }, [
                _c("img", {
                  attrs: {
                    src: _vm.brandingImagesPath(
                      "/images/specs-icons/aircon-icon.svg"
                    ),
                    alt: "Air con",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vehicle-spec-item-description" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.labels.airCon) +
                    "\n            "
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.currentVehicle.transmission
          ? _c("div", { staticClass: "icon-spec" }, [
              _c("div", { staticClass: "vehicle-spec-item-icon" }, [
                _c("img", {
                  attrs: {
                    src: _vm.brandingImagesPath(
                      "/images/specs-icons/" + _vm.transmission.icon
                    ),
                    alt: "Transmission",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vehicle-spec-item-description" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.transmission.label) +
                    "\n            "
                ),
              ]),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }